import React from "react";
import "./PasswordChanged.css";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
function PasswordChanged() {
  const dispatch = useDispatch();
  const handleBackToSignInClick = () => {
    dispatch(setActiveComponent("signIn"));
  };

  return (
    <div className="PasswordChanges">
      <div className="passwordChangedContainer">
        <span className="signInText">Sign In</span>
        <span className="signInText2"> Sign In to Unite on Amalgamate</span>
        <img
          src="/Assets/PasswordChanged/TickIcon.svg"
          alt="no img found"
          className="tickIcon"
        />
        <div className="backToLoginContainer">
          <button className="btnContainer" onClick={handleBackToSignInClick}>
            <span className="btnText">
              Back to Sign In
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default PasswordChanged;
